<template>
  <Button :class="$style.button" v-bind="$attrs" v-on="$listeners">
    <slot name="icon" :svg="svg">
      <SvgIcon
        :svg="svg"
      />
    </slot>
    <slot name="text" :class="$style.text">
      <div :class="$style.text">
        <slot></slot>
      </div>
    </slot>
  </Button>
</template>

<script>
import Button from './Button'
import SvgIcon from './SvgIcon'

export default {
  components: {
    Button,
    SvgIcon,
  },
  props: {
    svg: {
      type: String,
    },
  },
}
</script>

<style lang="scss" module>
.button {
  @apply flex;
  @apply items-center;
}

.text {
  font-size: 1.6rem;
}
</style>
